import { useQuery } from '@tanstack/react-query';
import { eventDetailsApi } from '../api/events/detailsApi';
import { EventDetails } from '../types/eventDetails.types';

export const useEventDetails = (eventSlug: string | undefined) => {
  console.log('useEventDetails hook called with eventSlug:', eventSlug);
  
  return useQuery<EventDetails, Error>({
    queryKey: ['eventDetails', eventSlug],
    queryFn: () => {
      console.log('useEventDetails queryFn executing with:', eventSlug);
      if (!eventSlug) {
        throw new Error('Event slug is required');
      }
      return eventDetailsApi.getDetails(eventSlug);
    },
    enabled: !!eventSlug,
    staleTime: 5 * 60 * 1000, // Consider data fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // Keep in cache for 10 minutes
  });
};